import React from 'react';
import { motion } from 'framer-motion';
import { Building } from 'lucide-react';
import PageHeader from '../../components/UI/PageHeader';
import MerchantSpreadsheet from '../../components/Merchants/MerchantSpreadsheet';

const MerchantRecords = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-8"
    >
      <PageHeader
        title="Merchant Records"
        subtitle=""
        icon={Building}
      />
      
      <MerchantSpreadsheet userRole="admin" />
    </motion.div>
  );
};

export default MerchantRecords;